import React, { Fragment, useEffect, useState } from 'react'
import FilterComponent from '../../../shared_elements/components/filter_component';
import { withRouter } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { dayMonthDateFormat } from '../../../constants';
import moment from 'moment';
import { Paper, Grid, TableCell, TableHead, TableBody, TableRow, Table, TableSortLabel } from '@material-ui/core';
import { ExportMenu } from '../../../shared_elements';
import { servceablefilterOption } from '../containers';
import { globalGetService, globalExportService } from '../../../utils/globalApiServices';
import { checkApiStatus, downloadFileType } from '../../../utils';
import { PageLoader, EmptyCollection } from "../../../shared_elements"
import STableLoader from '../../../shared_elements/components/skeleton_loader/STableLoader';
import { trackActivity } from '../../../utils/mixpanel';
import Pagination from '../../../shared_elements/components/Pagination';
import { smbcInstance } from '../../../shared_elements/components';
function ServiceableEngine() {
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const [filter, setFilter] = useState({})
	const [serviceableData, setServiceableData] = useState([])
	const [pageLoader, setPageLoader] = useState(false)
	const [skeltonLoader, setSkeltonLoader] = useState(false)
	const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
	const [filterEngineTypes, setFilterEngineTypes] = useState([]);
	const [filterLessee, setFilterLessee] = useState([]);

	useEffect(() => {
		ServivceableApi()
		getLessee()
		getEngineTypes()
		trackActivity('Engine Off Wing Serviceable Tab - Airworthiness Management', {
			event_type: 'Page Visited',
			page_title: 'Engine Off Wing Serviceable',
		})
	}, [])

	const ServivceableApi = (query, loader) => {
		loader === "pageLoader" ? setPageLoader(true) : setSkeltonLoader(true)
		globalGetService(smbcInstance ? `camo/smbc_engine_off_wing_report_serviceable/?per_page=20`:`camo/engine_off_wing_report_serviceable/?per_page=20`, query)
			.then(response => {
				if (checkApiStatus(response)) {
					loader === "pageLoader" ? setPageLoader(false) : setSkeltonLoader(false)
					setServiceableData(response.data)
					setFilter(query)
				}
			})

	}
	const createSortHandler = (key) => {
		let sortQuery = { sort: key };
		if (sortInfo.sort === key) {
			sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
		} else {
			sortQuery = { ...sortQuery, sort_by: 'asc' }
		}
		setSortInfo(sortQuery)
		ServivceableApi({ ...sortQuery, page: 1, per_page: 20 }, 'pageLoader');
	}

	const exportserviciable = (extension) => {
		setPageLoader(true)
		let queryParams = Object.assign({}, filter);
		delete queryParams.per_page
		globalExportService(smbcInstance ? `/camo/smbc_engine_off_wing_report_serviceable/?download=${extension}` : `/camo/engine_off_wing_report_serviceable/?download=${extension}`, { ...queryParams })
			.then((response) => {
				setPageLoader(false)
				if (checkApiStatus(response)) {
					downloadFileType(response.data, `Serviceable Engine Reports`, extension);
					enqueueSnackbar("Serviceable Report Download Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, });
					trackActivity('Serviceable Report Exported Success - Airworthiness Management', {
						event_type: 'Exported Success',
						page_title: 'Engine Off Wing Serviceable Report',
						file_extension: extension,
						sucess_msg: 'Serviceable Report Download Successfully.'
					})
				} else {
					enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
					trackActivity('Serviceable Report Exported Failed - Airworthiness Management', {
						event_type: 'Exported Failed',
						page_title: 'Engine Off Wing Serviceable Report',
						file_extension: extension,
						error_msg: 'Something went wrong.'
					})
				}
			});
	}

	const getEngineTypes = () => {
		globalGetService(`console/engine-types/`, { distinct: 1 })
			.then(response => {
				if (checkApiStatus(response)) {
					setFilterEngineTypes(response.data.data.engineTypes)
				}
			})
	}
	const getLessee = () => {
		globalGetService(`console/lessees/?distinct=1`)
			.then(response => {
				if (checkApiStatus(response)) {
					setFilterLessee(response.data.data.lessees)
				}
			})
	}

	const tableSorting = (key, name) => {
		return <TableSortLabel active={sortInfo.sort === key ? true : false} direction={sortInfo.sort === key ? sortInfo.sort_by : 'asc'} onClick={() => createSortHandler(key)} > {name}</TableSortLabel>
	}
	const filterObj = Object.assign({}, filter, delete filter?.page, delete filter?.sort, delete filter?.sort_by,)
	let filterOptions = Object.assign({}, servceablefilterOption);
	filterOptions = {
		...filterOptions,
		engine_type: {
			...filterOptions.engine_type,
			options: filterEngineTypes
		},
		lessee: {
			...filterOptions.lessee,
			options: filterLessee
		},
	}

	return (
		<Fragment >
			<Paper square style={{ height: "50px" }}>
				<Grid container spacing={2}>
					<Grid md={10}>
						<div style={{ padding: "8px 10px" }}>
							<FilterComponent
								filter={filterObj}
								filterMenu={filterOptions}
								getResponseBack={(applyFilter) => ServivceableApi({ ...applyFilter, page: 1, per_page: serviceableData?.data?.pagination?.per_page }, 'pageLoader')}
							/>
						</div>
					</Grid>
					<Grid md={2} style={{ margin: 'auto' }}>
						<ul className='list-inline' style={{ float: 'right' }}>
							<li className='list-inline-item' style={{ margin: '8px 24px' }}>
								<ExportMenu
									exportReportFn={(file) => exportserviciable(file.extension)}
									files={[{ title: 'EXCEL', extension: 'xlsx' }]}
									title='Export'
								/>
							</li>
						</ul>
					</Grid>
				</Grid>
			</Paper>
			{skeltonLoader ? <STableLoader count={7} /> : <Paper square style={{ marginBottom: "5px" }}>
				<div className='engine-off-wing' style={{ height: (window.innerHeight - 300) + 'px' }} >
					<Table stickyHeader aria-label="sticky table">
						<TableHead>
							<TableRow >
								<TableCell style={{ minWidth: '200px' }} >{tableSorting('engine_type', 'Engine Type ')}</TableCell>
								<TableCell >{tableSorting('esn', 'Engine SN')}</TableCell>
								<TableCell style={{ minWidth: '200px' }} >{tableSorting('current_lessee', 'Current Lessee')}</TableCell>
								<TableCell >{tableSorting('tsn', 'TSN')}</TableCell>
								<TableCell >{tableSorting('csn', 'CSN')}</TableCell>
								<TableCell style={{ minWidth: '200px' }} >{tableSorting('fh_fc_since_new', 'FH:FC (Since New) ')}</TableCell>
								<TableCell > {tableSorting('tslsv', smbcInstance ? 'TSPR' : 'TSLSV')}</TableCell>
								<TableCell >{tableSorting('cslsv', smbcInstance ? 'CSPR' : 'CSLSV')}</TableCell>
								<TableCell style={{ minWidth: '200px' }}>{tableSorting('fh_fc_since_last_pr', 'FH:FC (Since Last SV)')}</TableCell>
								<TableCell >{tableSorting('status', 'Status')}</TableCell>
								<TableCell >{tableSorting('location', 'Location')}</TableCell>
								<TableCell style={{ minWidth: '200px' }}>{tableSorting('preservation_date', 'Preservation Date')}</TableCell>
								<TableCell style={{ minWidth: '250px' }}>{tableSorting('preservation_expiry_date', 'Preservation  Expiry Date')}</TableCell>
								<TableCell style={{ minWidth: '250px' }}>{tableSorting('days_to_preservation_expiry', 'Days to Preservation Expiry')}</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{serviceableData?.data?.results.map((item, index) =>
								<TableRow>
									<TableCell >{item.engine_type || '--'}</TableCell>
									<TableCell >{item.esn || '--'}</TableCell>
									<TableCell >{item.current_lessee || '--'}</TableCell>
									<TableCell >{item.tsn >= (0 || "0") ? item.tsn  : '--'}</TableCell>
									<TableCell >{item.csn >= (0 || "0") ? item.csn  : '--'}</TableCell>
									<TableCell >{item.fh_fc_since_new || '--'}</TableCell>
									<TableCell >{item.tslsv >= (0 || "0") ? item.tslsv  : '--'}</TableCell>
									<TableCell >{item.cslsv >= (0 || "0") ? item.cslsv  : '--'}</TableCell>
									<TableCell >{item.fh_fc_since_last_pr || '--'}</TableCell>
									<TableCell >{item.status || '--'}</TableCell>
									<TableCell >{item.location || '--'}</TableCell>
									<TableCell>{item.preservation_date ? moment(item.preservation_date).format(dayMonthDateFormat) : "--"}</TableCell>
									<TableCell>{item.preservation_expiry_date ? moment(item.preservation_expiry_date).format(dayMonthDateFormat) : "--"}</TableCell>
									<TableCell >{item.days_to_preservation_expiry === 0 ? 0 : item.days_to_preservation_expiry || '--'}</TableCell>
								</TableRow>
							)}
						</TableBody>
					</Table>
					{!serviceableData?.data ? <EmptyCollection description={'No records found'} /> : null}
				</div>
				<Pagination
					pagination={serviceableData?.data?.pagination}
					onChangePage={(event, newPage) => ServivceableApi({ ...filter, page: newPage + 1, per_page: serviceableData?.data?.pagination?.per_page || 20 }, 'pageLoader')}
					onChangeRowsPerPage={(event) => ServivceableApi({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
				/>
			</Paper>}
			{pageLoader ? <PageLoader /> : null}
		</Fragment >
	)
}

export default withRouter(ServiceableEngine)